import { NgModule, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { Notfound } from './core/components/notfound/notfound';

import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

import { StyleClassModule } from 'primeng/styleclass';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { MsalModule, MsalInterceptor, MsalService } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { environment } from './environments/environment';

import { SocialLoginModule } from '@abacritt/angularx-social-login';

import { provideTranslateService, TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

// NOSONAR: Deprecated API in Angular 21, kept for PrimeNG compatibility
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

const msalConfig = environment.mslConfig;

const isIE =
  window.navigator.userAgent.includes('MSIE ') ||
  window.navigator.userAgent.includes('Trident/');

@NgModule({
  declarations: [
    App,
    Notfound
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    StyleClassModule,
    SocialLoginModule,
    TranslateModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: msalConfig.clientId,
          authority: msalConfig.authority,
          redirectUri: msalConfig.redirectUri
        },
        cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: isIE,
        },
      }),
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: ["user.read"],
        },
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
          ["https://graph.microsoft.com/v1.0/me", ["user.read"]]
        ]),
      }
    ),
    
  ],
  providers: [
    // NOSONAR: Deprecated API in Angular 21, kept for PrimeNG compatibility
    provideAnimationsAsync(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      })
    }),
    provideAppInitializer(() => inject(MsalService).instance.initialize()),
    providePrimeNG({
      theme: {
        preset: Aura,
  
        options: {
          
          darkModeSelector: '.app-dark',

        },
      },
    }),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
  ],
  bootstrap: [App]
})
export class AppModule { }
